import React from 'react';
import { Container, Col, Row } from 'react-grid-system';
import DataColumn from '../atoms/DataColumn';
import DataBlurb from '../molecules/data/DataBlurb';
import DataBarGraph from '../molecules/data/DataBarGraph';

interface PrimaryDataProps {
  data: AggregateDataType | BlockGroupType;
}

const PrimaryData: React.FC<PrimaryDataProps> = ({ data }) => {
  return (
    <>
      <h3>Community Characteristics</h3>
      <Row>
        <Col sm={6}>
          <DataColumn>
            <h4>Reported Age</h4>
            <DataBarGraph
              percent={parseFloat(data.ep_age17_value.toFixed(2))}
              label="17 or Younger"
              risk={data.ep_age17_label}
            />
            <DataBarGraph
              percent={parseFloat((100 - (data.ep_age17_value + data.ep_age65_value)).toFixed(2))}
              label="18-64"
            />
            <DataBarGraph
              percent={parseFloat(data.ep_age65_value.toFixed(2))}
              label="65 and Older"
              risk={data.ep_age65_label}
            />
          </DataColumn>
          <DataColumn>
            <Row align="center">
              <Col sm={6}>
                <h4>Neighborhood<br />Statistics</h4>
              </Col>
              <Col sm={6}>
                <DataBlurb
                  value={data.eqi_land_walkability_value.toFixed(2)}
                  label="Walkability Index"
                  risk={data.eqi_land_walkability_label}
                />
              </Col>
              <Col sm={6}>
                <DataBlurb
                  value={(data.poverty_belowpoverty_value * 100).toFixed(2) + '%'}
                  label="Poverty Rate"
                  risk={data.poverty_belowpoverty_label}
                />
              </Col>
              <Col sm={6}>
                <DataBlurb
                  value={data.ep_uninsur_value.toFixed(2) + '%'}
                  label="Uninsured"
                  risk={data.ep_uninsur_label}
                />
              </Col>
            </Row>
          </DataColumn>
        </Col>
        <Col sm={6}>
          <DataColumn>
            <h4>Reported Race or Ethnicity</h4>
            <DataBarGraph
              label="Asian / Pacific Islander"
              percent={data.race_asian_pi * 100}
            />
            <DataBarGraph
              label="Black"
              percent={data.race_black * 100}
            />
            <DataBarGraph
              label="Hispanic"
              percent={data.ethnicity_hispanic * 100}
            />
            <DataBarGraph
              label="Native American"
              percent={data.race_native_amer * 100}
            />
            <DataBarGraph
              label="Other"
              percent={data.race_other * 100}
            />
            <DataBarGraph
              label="White"
              percent={data.race_white * 100}
            />
          </DataColumn>
        </Col>
      </Row>
      <Row>
        <Col>
          <DataColumn>
            <Container fluid style={{
              paddingLeft: 0,
              paddingRight: 0,
            }}>
              <Row>
                <Col sm={3}>
                  <h4>Health literacy</h4>
                </Col>
                <Col sm={9}>
                  <h4>Rates of preventative screening</h4>
                </Col>
              </Row>
              <Row align="start">
                <Col sm={3}>
                  <DataBlurb
                    value={data.ep_limeng_value.toFixed(2) + '%' }
                    label="Speak English 'Less&nbsp;than Well'"
                    risk={data.ep_limeng_label}
                  />
                </Col>
                <Col sm={9}>
                  <Row>
                    <Col sm={4}>
                      <DataBlurb 
                        value={data.plcr_mammouse_value.toFixed(2) + '%'}
                        label="Breast Cancer Screening"
                        risk="vs. 78.2% Nat'l. Prevalence"
                      />
                    </Col>
                    <Col sm={4}>
                      <DataBlurb 
                        value={data.plcr_cervical_value.toFixed(2) + '%'}
                        label="Cervical Cancer Screening"
                        risk="vs. 78.0% Nat'l. Prevalence"
                      />
                    </Col>
                    <Col sm={4}>
                      <DataBlurb 
                        value={data.plcr_colon_screen_value.toFixed(2) + '%'}
                        label="Colorectal Cancer Screening"
                        risk="vs. 71.8% Nat'l. Prevalence"
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </DataColumn>
        </Col>
      </Row>
    </>
  );
};

export default PrimaryData;
